import { render, staticRenderFns } from "./confirm-delete-admin.vue?vue&type=template&id=64401923&scoped=true"
import script from "./confirm-delete-admin.vue?vue&type=script&lang=js"
export * from "./confirm-delete-admin.vue?vue&type=script&lang=js"
import style0 from "./confirm-delete-admin.vue?vue&type=style&index=0&id=64401923&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64401923",
  null
  
)

export default component.exports